import { FC, useEffect, useState } from 'react';
import { Callback } from '../../app/[brand]';

const Import: FC = () => {
  const [isAuthentCallback, setIsAuthentCallback] = useState(
    (window.location?.href?.split('/callback?') ?? []).length > 1
  );

  useEffect(() => {
    const isCallback =
      (window.location?.href?.split('/callback?') ?? []).length > 1;
    setIsAuthentCallback(isCallback);
    // Si ce n'est pas un callback et qu'il n'y a pas de hash => on est sur une ancienne url, on redirige vers la nouvelle URL équivalente
    if (!isCallback && (window.location?.hash ?? '').length < 1) {
      window.location.replace(
        window.location.origin + '/#' + (window.location.pathname ?? '')
      );
    }
  }, [, window.location, location]);

  return <>{isAuthentCallback && <Callback />}</>;
};

export default Import;
